import { useState } from 'react';

import { BREAKPOINTS } from 'constants/defaults.constant';

import { useWindowSize } from 'hooks/useWindowSize';

import { FooterListItem, FooterListItemProps } from './FooterListItem';
import { FooterSectionHeader } from './FooterSectionHeader';

type CollapsibleFooterSectionProps = {
  title: string;
  items: FooterListItemProps[];
  className?: string;
  defaultExpanded?: boolean;
  variant?: 'default' | 'referral' | 'events';
};

export const CollapsibleFooterSection = ({
  title,
  items,
  className,
  defaultExpanded = false,
  variant = 'default',
}: CollapsibleFooterSectionProps) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const [width] = useWindowSize();
  const isMobile = width < BREAKPOINTS.MOBILE_BREAKPOINT;

  // Don't render empty sections
  if (items.length === 0) {
    return null;
  }

  const toggleExpanded = () => {
    if (!isMobile) {
      return;
    }

    setIsExpanded(!isExpanded);
  };

  return (
    <div className={className}>
      <div
        className="tw-flex tw-cursor-pointer tw-items-center tw-justify-between lg:tw-cursor-default"
        onClick={toggleExpanded}
      >
        <FooterSectionHeader title={title} variant={variant} />
        <div className="tw-block lg:tw-hidden">
          {isExpanded ? (
            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" className="tw-text-white">
              <path
                d="M1 1L6 6L11 1"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ) : (
            <svg width="8" height="12" viewBox="0 0 8 12" fill="none" className="tw-text-white">
              <path
                d="M1 1L6 6L1 11"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </div>
      </div>

      <ul
        className={`tw-m-0 tw-p-0 tw-transition-all tw-duration-300 lg:tw-block ${
          isExpanded ? 'tw-mt-4 tw-block' : 'tw-hidden'
        }`}
      >
        {items.map((item) => (
          <FooterListItem key={item.title} {...item} variant={variant} />
        ))}
      </ul>
    </div>
  );
};
